var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaWeightHanging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C7.1775 3 6.5 3.6775 6.5 4.5C6.5 4.676 6.537 4.842 6.594 5H4.094L4.0155 5.4065L2.5155 12.9065L2.5 12.953V14H13.5V12.953L13.4845 12.9065L11.9845 5.4065L11.906 5H9.406C9.46606 4.84004 9.49786 4.67085 9.5 4.5C9.5 3.6775 8.8225 3 8 3ZM8 4C8.2815 4 8.5 4.219 8.5 4.5C8.5 4.7815 8.281 5 8 5C7.7185 5 7.5 4.781 7.5 4.5C7.5 4.2185 7.719 4 8 4ZM4.906 6H11.094L12.5 13H3.5L4.906 6Z",
    fill: "#202020",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaWeightHanging);
export default __webpack_public_path__ + "static/media/la_weight-hanging.2831c014cfa559dcc446386e16f477e7.svg";
export { ForwardRef as ReactComponent };